import BuefyDropdown from "buefy/src/components/dropdown/Dropdown.vue";
import WrapperDropdown from "./b-dropdown-wrapper.vue";

export default {
	install(Vue) {
		Vue.component(BuefyDropdown.name, WrapperDropdown);
	},
};
